module.exports = __webpack_public_path__ + "img/activities-17.210a064d.jpg";